export const isEmpty = (val: string | undefined | null | number | object): boolean => {
	if (val === null) {
		return true
	}
	if (typeof val === "undefined") {
		return true
	}
	if (typeof val === "string" && val === "") {
		return true
	}
	if (Array.isArray(val) && val.length < 1) {
		return true
	}
	if (typeof val === "object" && val.constructor.name === "Object" && Object.keys(val).length < 1 && Object.getOwnPropertyNames(val).length < 1) {
		return true
	}
	if (typeof val === "object" && val.constructor.name === "String" && Object.keys(val).length < 1) {
		return true
	}
	return false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPrimitive = (value: any) => {
	const type = typeof value
	if (type === "string" || type === "number") {
		return true
	}
	return false
}
